import React, { memo } from 'react';
import { string, func } from 'prop-types';
import { withLang } from '../../../../i18n';
import styles from '../../surveyParticipantsEditor.module.css';
import { participantType, participantIdTypeValues } from '../../../../constants/types';
import RemoveParticipantButton from '../RemoveParticipantButton';
import Tag from '../../../Tag';

const TeacherRow = ({
  name, participant, translate: t
}) => {
  const {
    email, error, new: isNew, responseDate, externalId
  } = participant;
  const showRemoveButton = !responseDate;
  const rowStyle = error ? styles.notFound : '';
  const nameColumn = error ? t(`surveyParticipantsEditor.teacherParticipantsEditor.${error}`) : name;

  return (
    <tr className={`${rowStyle} ${styles.item}`}>
      <td className={styles.nameColumn}>{nameColumn}</td>
      <td>
        {email} {isNew && <Tag text={t('common.new')} inverse />}
      </td>
      <td className={styles.actionsColumn}>
        {error && <span className={`${styles.alert} icon--alert`} />}
        {showRemoveButton && (
          <RemoveParticipantButton
            participantId={externalId || email}
            participantIdType={externalId ? participantIdTypeValues.EXTERNAL_ID : participantIdTypeValues.EMAIL}
            translate={t}
          />
        )}
      </td>
    </tr>
  );
};

TeacherRow.propTypes = {
  name: string.isRequired,
  participant: participantType.isRequired,
  translate: func.isRequired
};

export default memo(withLang(TeacherRow));
